/**
 * compose.ts
 * ----------------
 * Allows composition of two functions, i.e. compose(f, g) is g(f(...)).
 */

/**
 * Allows composition of two functions, i.e. compose(f, g) is g(f(...)).
 * @param f First function
 * @param g Second function
 * @returns Composition of first function with second function
 */
export function compose<TFirstIn, TFirstOut, TSecondOut> (
    f: (x: TFirstIn) => TFirstOut,
    g: (y: TFirstOut) => TSecondOut
): (x: TFirstIn) => TSecondOut {
    return x => g(f(x));
}
